import BoVersionTypes from 'store/actionTypes/boVersion'
import { boVersionAPI } from 'store/api'
import { bindRequestLogic } from './utils'

const getBOVersions = bindRequestLogic({
  clientFunc: boVersionAPI.getBOVersions,
  type: BoVersionTypes.GET_BO_VERSIONS_REQUEST,
  successType: BoVersionTypes.GET_BO_VERSIONS_SUCCESS,
  failType: BoVersionTypes.GET_BO_VERSIONS_FAILED,
  isQueryParam: true
})

const addBOVersion = bindRequestLogic({
  clientFunc: boVersionAPI.addBOVersion,
  type: BoVersionTypes.ADD_BO_VERSION_REQUEST,
  successType: BoVersionTypes.ADD_BO_VERSION_SUCCESS,
  failType: BoVersionTypes.ADD_BO_VERSION_FAILED
})

const updateBOVersion = bindRequestLogic({
  clientFunc: boVersionAPI.updateBOVersion,
  type: BoVersionTypes.UPDATE_BO_VERSION_REQUEST,
  successType: BoVersionTypes.UPDATE_BO_VERSION_SUCCESS,
  failType: BoVersionTypes.UPDATE_BO_VERSION_FAILED
})

const deleteBOVersion = bindRequestLogic({
  clientFunc: boVersionAPI.deleteBOVersion,
  type: BoVersionTypes.DELETE_BO_VERSION_REQUEST,
  successType: BoVersionTypes.DELETE_BO_VERSION_SUCCESS,
  failType: BoVersionTypes.DELETE_BO_VERSION_FAILED
})

export default [getBOVersions, addBOVersion, updateBOVersion, deleteBOVersion]
